// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"93":"0d1ceed730a53e55","4784":"e9281664650a3dcb","7580":"ca4f83f499415f36"}[chunkId] + ".css";
};